module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "hero_prolific_prep.2f3365b6.mp4";